import FormsMixin from "@/mixins/FormsMixin";
import { Component } from "vue-property-decorator";

import Template from "./template.vue";

@Component({
    mixins: [Template],
  })
  export default class Ventas extends FormsMixin {
  }